import { render, staticRenderFns } from "./bill.vue?vue&type=template&id=1014ec82&scoped=true"
import script from "./bill.vue?vue&type=script&lang=js"
export * from "./bill.vue?vue&type=script&lang=js"
import style0 from "./bill.vue?vue&type=style&index=0&id=1014ec82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1014ec82",
  null
  
)

export default component.exports